import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { defineStore } from 'pinia';

import { holdConsultationCall } from '@/api/apiService';

export const useReceiveCallStore = defineStore('receiveCall', () => {
  const name = ref('');
  const visible = ref(false);
  const code = ref(null);
  const chatId = ref(null);
  const router = useRouter();

  const receive = () => {
    visible.value = false;
    connectCallInNewWindow(code.value, chatId.value);
    code.value = null;
    chatId.value = null;
  };

  const show = (requestName, newCode, newChatId) => {
    name.value = requestName;
    code.value = newCode;
    chatId.value = newChatId;
    visible.value = true;
  };

  const hold = () => {
    visible.value = false;
    holdConsultationCall(chatId.value);
  };

  const close = () => {
    visible.value = false;
  };

  const connectCallInNewWindow = (code, chatId) => {
    const newUrl = router.resolve({
      name: 'chat-entrance',
      params: { code },
    }).href;
    window.open(newUrl, '_blank');
  };

  return {
    visible,
    name,
    receive,
    show,
    hold,
    close,
    connectCallInNewWindow,
  };
});
